<template>
  <nav id="topnav" class="defaultscroll is-sticky bg-white dark:bg-slate-900">
    <div class="container">
      <!-- Logo container-->
      <a class="logo pl-0" href="/">
        <img :src="logoUrl" class="inline-block dark:hidden" alt="" />
        <img src="../assets/images/logoBSD/logo-BSD-W-Text.png.webp" class="inline-block dark:inline-block" alt="" />
      </a>
      <!-- End Logo container-->

      <div class="menu-extras">
        <div class="menu-item">
          <!-- Mobile menu toggle-->
          <a class="navbar-toggle" id="isToggle">
            <div class="lines" @click="menuMobileToggle">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
          <!-- End mobile menu toggle-->
        </div>
      </div>

      <!--begin navigation-->
      <div id="navigation" style="display: none">
        <!-- Navigation Menu-->
        <ul class="navigation-menu _nav-light">
          <li><router-link class="sub-menu-item" to="/">ACCEUIL</router-link></li>

          <li><router-link class="sub-menu-item" to="/qrLink">QR SURVEY</router-link></li>

          <li><router-link class="sub-menu-item" to="/comptoir">ELECTRO SURVEY</router-link></li>

          <li><router-link class="sub-menu-item" to="/standTouch">TOUCH SURVEY</router-link></li>

          <li><router-link class="sub-menu-item" to="/contact">Contact</router-link></li>
          <li class="mb-3"></li>
        </ul>
        <!--end navigation menu-->
      </div>
      <!--end navigation-->
    </div>
    <!--end container-->

    <div class="fixed top-6 emoticoneTop z-50 w-auto h-24 overflow-hidden">
      <picture>
        <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f92a/512.webp" type="image/webp" />
        <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f92a/512.gif" alt="🤪" width="32" height="32" />
      </picture>
    </div>
  </nav>
</template>

<script>
import { API_BASE_URL } from "@/services/configs/environment";
import ConfigurationService from "@/services/modules/parametre.service";
export default {
  name: "NavBar",
  data() {
    return {
      showMenu: true,
      showSubMenu: false,
      logoUrl: "",
    };
  },
  mounted() {
    this.getParamsInfo();
  },
  methods: {
    getParamsInfo() {
      ConfigurationService.getInfo()
        .then((response) => {
          let info = response.data.data;

          this.logoUrl = API_BASE_URL + "" + info.logo;
        })
        .catch((error) => {});
    },

    menuMobileToggle() {
      var x = document.getElementById("navigation");
      if (x.style.display === "none") {
        x.style.display = "block";
      } else {
        x.style.display = "none";
      }
    },
  },
};
</script>

<style scoped>
.perso {
  background-color: #1a345f;
  color: white;
}

.sub-menu-item:hover {
  color: #0d3460;
}

.emoticoneTop {
  right: 8.5rem;
}
</style>
